import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=c6778dc0&scoped=true&"
import script from "./recent.vue?vue&type=script&lang=js&"
export * from "./recent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6778dc0",
  null
  
)

export default component.exports